import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { withRouter } from 'react-router-dom';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@/modules/common/components/Card';
import Spinner from '@/modules/common/components/Spinner';
import ErrorFetch from '@/modules/common/components/ErrorFetch';
import { withFetch } from '~/hocs/fetch';
import { parseTime, formatTime } from '~/common';
import Form from './Form';

const initialValues = {
    leadsUniqueDays: 0,
    showInLeadsMenu: false,
    showInNotesMenu: false,
    showTypeCol: false,
    showDtsCol: false,
    showAdvSub2Col: false, affiliateShowAdvSub2Col: false,
    showTransactionIdCol: false,
    botTime: {
        from: null,
        to: null,
    },
    botInterval: 0,
    extraFlag1: false,
};

const initialErrors = {
    botTime: {
        from: '',
        to: '',
    },
    botInterval: '',
};

let abortController1;
let abortController2;

const Settings = (props) => {
    const name = props.match.params.name;

    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState(true);
    const [cfg, setCfg] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState(initialErrors);

    const fetch = () => {
        abortController1 = new AbortController();
        setLoading(true);
        props.fetch.get(`/api/cfg/offers/${name}/`, abortController1)
            .then(({ok, data}) => {
                if (ok) {
                    setCfg(data);
                }
                setLoading(false);
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    setLoading(false);
                }
            })
            .finally(() => {
                abortController1 = null;
            });
    };

    useEffect(() => {
        fetch();
        return () => {
            if (abortController1) {
                abortController1.abort();
            }
            if (abortController2) {
                abortController2.abort();
            }
        };
    }, []);

    useEffect(() => {
        if (cfg) {
            // noinspection JSUnresolvedVariable
            setValues({
                ...values,
                leadsUniqueDays: cfg.leads_unique_days,
                showInLeadsMenu: cfg.show_in_leads_menu,
                showInNotesMenu: cfg.show_in_notes_menu,
                showTypeCol: cfg.show_type_col,
                showDtsCol: cfg.show_dts_col,
                showAdvSub2Col: cfg.show_adv_sub2_col, affiliateShowAdvSub2Col: cfg.affiliate_show_adv_sub2_col,
                showTransactionIdCol: cfg.show_transaction_id_col,
                botTime: {
                    from: (cfg.bot_time_from) ? parseTime(cfg.bot_time_from) : null,
                    to: (cfg.bot_time_to) ? parseTime(cfg.bot_time_to) : null,
                },
                botInterval: cfg.bot_interval,
                extraFlag1: cfg.extra_flag1,
            });
        }
    }, [cfg]);

    const handleSubmit = (event) => {
        abortController2 = new AbortController();
        event.preventDefault();
        setFetching(true);
        props.fetch.put(
            `/api/cfg/offers/${name}/`, {
                leads_unique_days: values.leadsUniqueDays,
                show_in_leads_menu: values.showInLeadsMenu,
                show_in_notes_menu: values.showInNotesMenu,
                show_type_col: values.showTypeCol,
                show_dts_col: values.showDtsCol,
                show_adv_sub2_col: values.showAdvSub2Col, affiliate_show_adv_sub2_col: values.affiliateShowAdvSub2Col,
                show_transaction_id_col: values.showTransactionIdCol,
                bot_time_from: (values.botTime.from) ? formatTime(values.botTime.from) : null,
                bot_time_to: (values.botTime.to) ? formatTime(values.botTime.to) : null,
                bot_interval: values.botInterval,
                extra_flag1: values.extraFlag1,
            },
            abortController2
        ).then(({ok, data}) => {
            if (ok) {
                setErrors(initialErrors);
                enqueueSnackbar('Настройки обновлены', {variant: 'success'});
            }
            else {
                let _errors = {...initialErrors};
                _errors.botTime.from = (data.bot_time_from) ? data.bot_time_from[0] : '';
                _errors.botTime.to = (data.bot_time_to) ? data.bot_time_to[0] : '';
                _errors.botInterval = (data.bot_interval) ? data.bot_interval[0] : '';
                setErrors(_errors);
            }
            setFetching(false);
        }).catch((error) => {
            if (error.name !== 'AbortError') {
                setFetching(false);
            }
        })
        .finally(() => {
            abortController2 = null;
        });
    };

    return (
        <Card id="offer-settings">
            <CardHeader title="Настройки"/>
            <CardContent className={(loading) ? 'loading' : ''}>
                {(!loading)
                    ? <>
                        {(cfg)
                            ? <Form cfg={cfg}
                                    values={values} setValues={setValues}
                                    errors={errors} setErrors={setErrors}
                                    onSubmit={handleSubmit} disabled={fetching}
                            />
                            : <ErrorFetch onClick={() => fetch()}/>
                        }
                    </>
                    : <Spinner/>
                }
            </CardContent>
        </Card>
    );
};

let Component = Settings;
Component = withRouter(Component);
Component = withFetch(Component);

export default Component;
